import React from 'react';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import FaceVerification from '../ui/FaceVerification';
import { X, ShieldCheck, WifiOff } from 'lucide-react';

export const FaceVerificationScreen = ({ isOnline, effectiveFaceDescriptor, onComplete, onCancel }) => {
  return (
    <div className="p-4 md:p-6 max-w-lg mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-indigo-950">Verifikasi Wajah</h1>
          <p className="text-gray-500">
            {isOnline ? 'Verifikasi identitas sebelum absensi' : 'Verifikasi wajah offline'}
          </p>
        </div>
        <Button variant="ghost" onClick={onCancel}>
          <X className="w-5 h-5" />
        </Button>
      </div>

      <Alert className="mb-4 border-blue-200 bg-blue-50">
        <ShieldCheck className="w-4 h-4 text-blue-600" />
        <AlertDescription className="text-blue-800">
          <strong>Anti-Spoofing Aktif:</strong> Anda akan diminta kedipkan mata untuk membuktikan ini bukan foto.
        </AlertDescription>
      </Alert>

      {!isOnline && (
        <Alert className="mb-4 border-amber-200 bg-amber-50">
          <WifiOff className="w-4 h-4 text-amber-600" />
          <AlertDescription className="text-amber-800">
            <strong>Mode Offline:</strong> Verifikasi wajah menggunakan data yang tersimpan di perangkat.
          </AlertDescription>
        </Alert>
      )}

      <FaceVerification
        mode="verify"
        referenceDescriptor={effectiveFaceDescriptor}
        onVerificationComplete={onComplete}
        onCancel={onCancel}
      />
    </div>
  );
};
